module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level9.dd29549a.png";